import React from "react";
import styled from "styled-components";

import {
    almostInvisibleShadedBackgroundColour, pageHeaderBackgroundColour, tableBorderColour
} from "../../style/styleConsts";

/**
 * A style-able horizontal strip of screen space, with width-constrained, centered children.
 *
 * This is used for the header, navigation, body etc.
 *
 * You can style the outer element further like:
 *
 *   styled with styled(Section)`
 *      background-colour: red;
 *   `.
 *
 * You can't style the inner one, but it's invisible anyway, so instead you'd style an immediate child.
 */

const PageSection = ({children, className}) => (
    <Container className={className}>
        <ContainerInner>
            {children}
        </ContainerInner>
    </Container>
);

export const Container = styled.div`
    min-width: 600px;
    padding: 0 18px;
`;

export const ContainerInner = styled.div`
    box-sizing: border-box;
    margin: 0 auto;
`;

export default PageSection;

export const BorderedPageSection = styled(PageSection)`
    border-bottom: 1px solid ${tableBorderColour};
    background-color: ${props => props.shaded ? almostInvisibleShadedBackgroundColour : "transparent"};
    padding: 0 30px;
    ${ContainerInner} {
        padding: 30px 0;
    }
`;

export const HeaderPageSection = styled(PageSection)`
    padding: 0 30px;
    ${ContainerInner} {
        padding: 30px 0;
    }
    background-color: ${pageHeaderBackgroundColour};
`;